import {
    useCallback
} from 'react';


export default function useViewListeningQuery() {

    return useCallback((listeningQueryId, listeningQueryTypeId = RivalIQ.enums.listeningQueryTypes.SavedSearch.id) => {
        RivalIQ.execute('history:navigate', 'listening/search', {
            params: {
                interstitial: true,
                listeningQueryId: listeningQueryId,
                listeningQueryTypeId: listeningQueryTypeId
            },
            trigger: true
        });
    }, []);

}
